import dayjs from "dayjs";
import { Avatar, Box, Button, CircularProgress, Grid, Stack, Typography, useMediaQuery } from "@mui/material";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { gridSpacing } from "../../../store/constants";
import { useTheme } from "@mui/material/styles";
import { BulkSmsCampaignCreationValues } from ".";
import SimCardIcon from "@mui/icons-material/SimCard";
import SendIcon from "@mui/icons-material/Send";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { useEffect, useState } from "react";
import { CampaignService } from "../../../assets/_services/campaign-service";
import { openSuccessDialog } from "../../../utils/ui-components/pop-ups/SuccessDialog";
import { useNavigate } from "react-router-dom";
import { currencyFormat } from "../../../utils/utils";

// Load the plugins
dayjs.extend(utc);
dayjs.extend(timezone);

function SMSCampaignReviewAndConfirm(props: {
  role: number;
  initialState: BulkSmsCampaignCreationValues;
  setInitialState: () => void;
  isLoadingMask: boolean;
  getChannelAndMaskList: (id: number | string) => void;
  isTimeDisabled: Function;
  channelList: {
    value: number | string;
    label: string;
    0: { unicode: number; non_unicode: number };
    1: { unicode: number; non_unicode: number };
  }[];
  maskList: { value: number | string; label: string; type: number };
  blackOutTime: {
    startTime: string;
    endTime: string;
  };
  optOutTemplate: {
    dialog: string;
    nonDialog: string;
  };
  handleBack: () => void;
  handleNext: () => void;
  suffix: string;
  tax: {
    value: number;
    percentage: number;
  };
  operatorValues: {
    onnet: number;
    offnet: number;
  };
}) {
  const theme: any = useTheme();
  const matchDownSM = useMediaQuery(theme.breakpoints.down("md"));

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const [campaignCost, setCampaignCost] = useState<number>(0);

  const createCampaign = () => {
    setIsLoading(true);
    if (Number(props.initialState.numberList.numberListType) === 1) {
      const formData = {
        campaign_name: props.initialState.campaignName,
        channel: String(props.initialState.channel),
        mt_port: props.maskList.label,
        s_time: props.initialState.startTime.format("YYYY-MM-DD HH:mm:ss"),
        e_time: props.initialState.endTime.format("YYYY-MM-DD HH:mm:ss"),
        msg: props.initialState.message.replace(props.suffix, "").trim(),
        schedule_now: props.initialState.scheduleNow,
        contact_list_ids: props.initialState.numberList.contactList.map((item) => item.id).join(","),
        parent_id: props.role === 1 ? props.initialState.parent_id.value : 0,
      };

      if (props.role === 1) {
        CampaignService.createAdminContactListBulkCampaign(formData).then((response) => {
          if (response.isSuccess) {
            openSuccessDialog("Success", `${response.data.comment}`);
            navigate(`/reports/bulk-sms-report/3/${response?.data?.data?.bulkCampaignTblId}`);
            setIsLoading(false);
            props.setInitialState();
          } else {
            setIsLoading(false);
          }
        });
      } else {
        CampaignService.createParentContactListBulkCampaign(formData).then((response) => {
          if (response.isSuccess) {
            openSuccessDialog("Success", `${response.data.comment}`);
            navigate(`/reports/bulk-sms-report/3/${response?.data?.data?.bulkCampaignTblId}`);
            setIsLoading(false);
            props.setInitialState();

            //   resetForm();
          } else {
            setIsLoading(false);
          }
        });
      }
    } else {
      let formData = new FormData();
      formData.append("campaign_name", props.initialState.campaignName);
      formData.append("mt_port", props.maskList.label);
      formData.append("s_time", props.initialState.startTime.format("YYYY-MM-DD HH:mm:ss"));
      formData.append("e_time", props.initialState.endTime.format("YYYY-MM-DD HH:mm:ss"));
      formData.append("msg", "Default message for personalized campaign");
      formData.append("schedule_now", props.initialState.scheduleNow ? String(1) : String(0));
      formData.append("file", props.initialState.numberList.file[0]);
      formData.append("parent_id", String(props.role === 1 ? props.initialState.parent_id.value : 0));

      if (props.role === 1) {
        CampaignService.createAdminPersonalizedCampaign(formData).then((response) => {
          if (response.isSuccess) {
            openSuccessDialog("Success", `${response.data.comment}`);
            navigate(`/reports/bulk-sms-report/3/${response?.data?.data?.bulkCampaignTblId}`);
            setIsLoading(false);
            props.setInitialState();
          } else {
            setIsLoading(false);
          }
        });
      } else {
        CampaignService.createParentPersonalizedCampaign(formData).then((response) => {
          if (response.isSuccess) {
            openSuccessDialog("Success", `${response.data.comment}`);
            navigate(`/reports/bulk-sms-report/3/${response?.data?.data?.bulkCampaignTblId}`);
            setIsLoading(false);
            props.setInitialState();

            //   resetForm();
          } else {
            setIsLoading(false);
          }
        });
      }
    }
  };

  useEffect(() => {
    calculateCampaignCost();
  }, []);

  const calculateCampaignCost = () => {
    let costAirtel = 0;
    let costDialog = 0;
    let costHutch = 0;
    let costMobitel = 0;

    props.initialState.numberList.contactList.map((item) => {
      costAirtel += item.cost.airtel_numbers;
      costAirtel += item.cost.airtel_numbers;
      costHutch += item.cost.hutch_numbers;
      costMobitel += item.cost.mobitel_numbers;
    });

    let campaingCostWithTax =
      costAirtel * props.operatorValues.offnet +
      costDialog * props.operatorValues.onnet +
      costHutch * props.operatorValues.offnet +
      costMobitel * props.operatorValues.offnet;

    campaingCostWithTax =
      (campaingCostWithTax * (100 + props.tax.percentage)) / 100 + (costAirtel + costDialog + costHutch + costMobitel) * props.tax.value;

    setCampaignCost(campaingCostWithTax);
  };

  return (
    <Grid container justifyContent="center" spacing={2}>
      <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
        <Box
          sx={{
            mt: 5,
            padding: "15px",
          }}
        >
          <Grid container spacing={gridSpacing}>
            <Grid item container xl={9} lg={8} md={7.5} xs={12} justifyContent={"center"} alignContent={"space-between"}>
              <Grid
                item
                sx={{
                  border: "1px solid",
                  borderColor: theme.palette.primary.light,
                  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
                  borderRadius: "10px",
                  py: "15px",
                }}
                xs={12}
                container
                columnSpacing={1}
                rowSpacing={3}
                justifyContent={"center"}
              >
                {props.role === 1 && (
                  <>
                    <Grid item xs={2.5}>
                      <Typography variant="caption" fontWeight={"bold"}>
                        Company Name :
                      </Typography>
                    </Grid>
                    <Grid item xs={9}>
                      <Typography>{props.initialState?.parent_id?.label}</Typography>
                    </Grid>
                  </>
                )}
                <Grid item xs={2.5}>
                  <Typography variant="caption" fontWeight={"bold"}>
                    Campaign Name :
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Typography>{props.initialState.campaignName}</Typography>
                </Grid>
                <Grid item xs={2.5}>
                  <Typography variant="caption" fontWeight={"bold"}>
                    Number Mask :
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Typography>{props.maskList.label}</Typography>
                </Grid>
                <Grid item xs={2.5}>
                  <Typography variant="caption" fontWeight={"bold"}>
                    Medium :
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Typography>SMS</Typography>
                </Grid>
                {Number(props.initialState.numberList.numberListType) === 1 && (
                  <>
                    <Grid item xs={2.5}>
                      <Typography variant="caption" fontWeight={"bold"}>
                        Channel :
                      </Typography>
                    </Grid>
                    <Grid item xs={9}>
                      <Typography>{props.channelList.find((channel) => channel.value === props.initialState.channel)?.label}</Typography>
                    </Grid>
                  </>
                )}
                <Grid item xs={2.5}>
                  <Typography variant="caption" fontWeight={"bold"}>
                    Start Date & Time :
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Typography>{dayjs(props.initialState.startTime).format("LLLL")}</Typography>
                </Grid>
                <Grid item xs={2.5}>
                  <Typography variant="caption" fontWeight={"bold"}>
                    End Date & Time :
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Typography>{dayjs(props.initialState.endTime).format("LLLL")}</Typography>
                </Grid>
                {Number(props.initialState.numberList.numberListType) === 1 && (
                  <>
                    <Grid item xs={2.5}>
                      <Typography variant="caption" fontWeight={"bold"}>
                        Estimate Campaign Cost :
                      </Typography>
                    </Grid>
                    <Grid item xs={9}>
                      <Typography>{currencyFormat(campaignCost, "LKR ", 2)}</Typography>
                    </Grid>
                  </>
                )}
                <Grid item xs={2.5}>
                  <Typography variant="caption" fontWeight={"bold"}>
                    Audience Base :
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Stack>
                    {Number(props.initialState.numberList.numberListType === 1) ? (
                      props.initialState.numberList.contactList.map((item, index) => (
                        <Typography key={index} display="flex" alignItems="center">
                          <ArrowRightIcon sx={{ marginRight: 1 }} /> {item.name}
                        </Typography>
                      ))
                    ) : (
                      <Typography display="flex" alignItems="center">
                        <ArrowRightIcon sx={{ marginRight: 1 }} /> Personalized File Upload
                      </Typography>
                    )}
                  </Stack>
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  py: 2,
                }}
              >
                <Button
                  color="primary"
                  variant="contained"
                  type="button"
                  onClick={props.handleBack}
                  startIcon={<NavigateBeforeIcon />}
                  disabled={isLoading}
                >
                  Back
                </Button>
                {/* <Box sx={{ width: 10 }} /> */}
                <Button
                  color="primary"
                  variant="contained"
                  type="button"
                  onClick={createCampaign}
                  startIcon={isLoading ? <CircularProgress size={"20px"} sx={{ mr: 1, color: "gray" }} /> : <SendIcon />}
                  disabled={isLoading}
                >
                  CONFIRM & SAVE
                </Button>
              </Grid>
            </Grid>
            {!matchDownSM && (
              <Grid item xl={3} lg={4} md={4.5} xs={12} container justifyContent="center">
                <Box
                  style={{
                    backgroundImage: `url(${require(theme.palette.mode === "light"
                      ? "../../../assets/images/ada_light_phone_background.PNG"
                      : "../../../assets/images/ada_dark_phone_background.PNG")})`,
                    width: "250px",
                    height: "540px",
                    overflowY: "auto",
                    backgroundSize: "cover",
                    borderRadius: 15,
                    border: `1px solid ${theme.palette.mode === "light" ? theme.palette.primary.light : theme.palette.secondary.main}`,
                  }}
                >
                  <Typography
                    variant="body1"
                    style={{
                      fontSize: 15,
                      fontWeight: "bold",
                      marginTop: props.maskList ? 35 : 75,

                      marginBottom: 20,
                      marginLeft: 35,
                      color: theme.palette.mode === "light" ? "black" : "white",
                    }}
                  >
                    {props.maskList?.label ?? ""}
                  </Typography>
                  <Grid
                    container
                    style={{
                      maxHeight: "100%",
                      overflowY: "auto",
                      padding: 10,
                    }}
                  >
                    <Avatar sx={{ width: 20, height: 20, marginTop: 0.5 }} />
                    <Box
                      style={{
                        width: "200px",
                        marginLeft: 5,
                        borderRadius: "0 20px 20px 20px",
                        minHeight: 30,
                        backgroundColor: theme.palette.mode === "light" ? "#efefef" : "#1f242b",
                      }}
                    >
                      {props.initialState.message ? (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: props.initialState.message.replace(/\r\n|\r|\n/g, "<br/>"),
                          }}
                          style={{
                            padding: 10,
                            inlineSize: "100%",
                            overflowWrap: "break-word",
                          }}
                        />
                      ) : null}
                    </Box>
                  </Grid>
                  {/* {Number(props.maskList.type) === 1 ? (
                  <Grid
                    container
                    style={{
                      maxHeight: "100%",
                      overflowY: "auto",
                      padding: 10,
                    }}
                  >
                    <Avatar sx={{ width: 20, height: 20, marginTop: 0.5 }} />
                    <Box
                      style={{
                        width: "200px",
                        marginLeft: 5,
                        borderRadius: "0 20px 20px 20px",
                        backgroundColor: theme.palette.mode === "light" ? "#efefef" : "#1f242b",
                        minHeight: 30,
                      }}
                    >
                      {props.initialState.message ? (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: props.initialState.message
                              .replace(
                                props.suffix,
                                props.suffix === "" ? "" : `\n${props.optOutTemplate.nonDialog.replace("#_MASK", props.maskList?.label ?? "")}`
                              )
                              .replace("\n", "<br/>"),
                          }}
                          style={{
                            padding: 10,
                            inlineSize: "100%",
                            overflowWrap: "break-word",
                          }}
                        />
                      ) : null}
                    </Box>
                  </Grid>
                ) : (
                  <></>
                )} */}
                </Box>
              </Grid>
            )}
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
}

export default SMSCampaignReviewAndConfirm;
